/* eslint-disable react/no-array-index-key */
import React from 'react';
import FilterGroup from './FilterGroup';
import useFilter from '../../hooks/useFilter';
export default function Filters(props) {
    const { children, initialNumOptions, ...useFiltersProps } = props;
    const { facets, setFilter, sliderStep, facetSliderSteps, clearFilters } = useFilter(useFiltersProps);
    return (React.createElement(React.Fragment, null, typeof children === 'function' ? (children({
        facets,
        setFilter,
        sliderStep,
        facetSliderSteps,
        clearFilters,
    })) : (React.createElement("div", { className: 'cio-filters' }, facets.map((facet) => (React.createElement(FilterGroup, { facet: facet, initialNumOptions: initialNumOptions, setFilter: setFilter, sliderStep: sliderStep, facetSliderSteps: facetSliderSteps, key: facet.name })))))));
}
